import { useQuery } from "@tanstack/react-query";
import { fetchDashboard } from "../services/dashboardService";

export const useDashboard = (page = 1) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["dashboard", page],
    queryFn: () => fetchDashboard(page),
    select: (response) => {
      return response.message || {};
    },
    staleTime: 1000 * 60 * 2,
  });

  return {
    dashboardData: data || null,
    loading: isLoading,
    error: error?.message || null,
  };
};
